import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useMediaQuery, useTheme } from '@material-ui/core';

export const useEditProfileDndControls = (id: string) => {
  const theme = useTheme();
  const onMobile = useMediaQuery(theme.breakpoints.down('md'));

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: id,
    animateLayoutChanges: () => false,
    transition: {
      duration: 500,
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0 : 1,
    touchAction: 'none',
  };

  return { attributes, listeners, style, setNodeRef, onMobile };
};
